export default __webpack_public_path__ + "static/partner_10-ef79a9e126a50dd92545a851af87141a.png";